import React from "react";
import { Box, Typography } from "@mui/material";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import { useTranslation } from "../../../hooks/useTranslation";

/**
 * The tutorials modal and the Vision page use separate videos with separate shapes (the
 * Platform landing page now shows a static image instead of a video):
 *
 *  - TUTORIAL_VIDEO_URL is the landscape getting-started video shown here — 1920x1080, the
 *    original that "Connect Yid Platform.mp4" held before it was overwritten on 2026-08-26.
 *  - VISION_VIDEO_URL is the Vision page's own film — also 1080x1920, portrait 9:16.
 *
 * Keep them distinct even if they ever point at the same file again.
 */
export const TUTORIAL_VIDEO_URL =
    "https://connectyidfile.nyc3.cdn.digitaloceanspaces.com/Tutorial%20Video.mp4";

export const VISION_VIDEO_URL =
    "https://connectyidfile.nyc3.cdn.digitaloceanspaces.com/ConnectYid%203.0.mp4";

const TutorialVideo: React.FC = () => {
    const { p } = useTranslation("tutorials");
    return (
        <Box
            sx={{
                width: "100%",
                mb: 3,
                borderRadius: 2,
                overflow: "hidden",
                bgcolor: "black",
                position: "relative",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    px: 2,
                    py: 1.25,
                    bgcolor: "primary.main",
                    color: "primary.contrastText",
                }}
            >
                <PlayCircleOutlineIcon fontSize="small" />
                <Typography variant="subtitle2" fontWeight={600}>
                    {p("watch_getting_started")}
                </Typography>
            </Box>
            <Box
                component="video"
                src={TUTORIAL_VIDEO_URL}
                controls
                playsInline
                preload="metadata"
                sx={{
                    display: "block",
                    width: "100%",
                    maxHeight: { xs: 220, sm: 340, md: 420 },
                    bgcolor: "black",
                    outline: "none",
                }}
            />
        </Box>
    );
};

export default TutorialVideo;
